import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { LocationInfoService } from './LocationInfo.service';
import { CommonapiService } from '../../Service/Commonapi.service';
import { GlocationService } from '../../Service/Glocation.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-LocationInfo',
  templateUrl: './LocationInfo.component.html'
})
export class LocationInfoComponent implements OnInit,OnDestroy {
  @Output() CallSuccessLocation: EventEmitter<any> = new EventEmitter();
  VP_Subscription: Subscription; show = false; success_load = false; value: any = "";
  constructor(private router: Router, private GLS: GlocationService, private api: CommonapiService, private PNS: LocationInfoService) { }
  data: any = {};
  ngOnInit() {
    this.VP_Subscription = this.PNS.Receive_info.subscribe((value) => {
     // console.log("value", value)
      this.show = true; this.success_load = false;
      this.data = value.data;
      console.log(" this.data ",  this.data )
    });
  }

  async CallContinue() {
    this.api.loader.startLoading();
    let _location: any ="";
   // let _location: any = await this.GLS.getLocation();
    await this.GLS.getLocation().then((rdata) => {
     // console.log("waiting data", rdata)
      _location = rdata;
      if (_location.status != 1) {
        this.api.Toast_alert("Location Services Disabled.please check");
      } else {
        this.close();
        if (this.data.callbackid)
          this.PNS.Callback({ callbackid: this.data.callbackid, location: _location ,data:this.data.sdata})
        else
          window.location.reload();
      }
      this.api.loader.stopLoading();
    })
  }
  close() {
    this.show = false;
  }

  ngOnDestroy() {
    this._unsubscribe()
  }
  _unsubscribe() {
    this.VP_Subscription.unsubscribe();
  }
}
